import axios from "axios";
import { API_URL } from "./conection";

export const getFormParams = async (params = {}) => {
  try {
    const res = await axios.get(`${API_URL}/form-params`, { params });
    return res.data;
  } catch (error) {
    console.error("Error en getFormParams:", error);
    return [];
  }
};

export const getFormParamsByType = async (type, params = {}) => {
  try {
    const res = await axios.get(`${API_URL}/form-params/${type}`, { params });
    return res.data;
  } catch (error) {
    console.error("Error en getFormParamsByType:", error);
    return null;
  }
};

export const addFormParamItem = async (type, data) => {
  const res = await axios.post(`${API_URL}/form-params/${type}/items`, data);
  return res.data;
};

// itemMongoId = _id de MongoDB
export const updateFormParamItem = async (type, itemMongoId, data) => {
  const res = await axios.put(`${API_URL}/form-params/${type}/items/${itemMongoId}`, data);
  return res.data;
};

// itemMongoId = _id de MongoDB
export const deleteFormParamItem = async (type, itemMongoId) => {
  const res = await axios.delete(`${API_URL}/form-params/${type}/items/${itemMongoId}`);
  return res.data;
};
